module.exports = __webpack_public_path__ + "img/isengard-3018-09-18.26312c5a.jpg";